/**
 * The token from the cookie Django checks, which the page names (the build does under the dev server).
 * Only that one: browsers still hold a csrftoken cookie from Insure's old backend, which fails CSRF.
 * Django rotates it on every sign-in, so a changed value also means someone signed in since it was read.
 */
export function getCsrfCookieToken(): string {
  // Prerendering runs without a document, and so without cookies.
  if (typeof document === 'undefined') return ''
  const prefix = `${window.__CAI_CONFIG__?.csrfCookieName || __CAI_CSRF_COOKIE_NAME__}=`
  const csrfCookie = document.cookie
    .split(';')
    .map((c) => c.trim())
    .find((c) => c.startsWith(prefix))
  return csrfCookie ? decodeURIComponent(csrfCookie.slice(prefix.length)) : ''
}
